import {getElementById} from "@acng/frontend-bounty/dom/query.js";
import {IS, NULLABLE, typeguard} from "@acng/frontend-bounty/typeguard.js";
import {RESOURCE_HIDDEN} from "../model/resource.js";

/**
 * @typedef {import("../model/resource.js").ResourceElement} ResourceElement
 */

/**
 * @param {ResourceElement} resource
 * @param {string[]} path
 * @param {boolean} [throwHidden]
 *
 * @returns {ResourceElement | null}
 */
export const find = (resource, path, throwHidden) => {
  /**
   * @type {ResourceElement | null}
   */
  let current = resource;

  for (const id of path) {
    const element = getElementById(current.content, id);

    ASSERT: typeguard("", element, NULLABLE(IS(HTMLTemplateElement)));

    current = element;

    if (!current) {
      break;
    }

    if (current[RESOURCE_HIDDEN] && throwHidden) {
      throw current;
    }
  }

  return current;
};
